module.exports = __webpack_public_path__ + "packs/media/images/home_4-64323bcd4818fa57c00eb353bb6eb1db.jpg";